import PropTypes from 'prop-types';

const itemPropType = PropTypes.shape({
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  count: PropTypes.number,
  selected: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
      count: PropTypes.number,
      selected: PropTypes.bool,
    }),
  ),
  shouldRenderAnIcon: PropTypes.bool,
});

export const RenderItemPropType = {
  item: itemPropType,
  isHighlighted: PropTypes.bool,
  onItemSelected: PropTypes.func.isRequired,
  buildTagProps: PropTypes.func,
};

export const RenderItemContentPropType = {
  ...RenderItemPropType,
  additionalClasses: PropTypes.string,
  tabIndex: PropTypes.number,
};

export const TreeNavPropType = {
  isHighlighted: PropTypes.bool,
  items: PropTypes.arrayOf(itemPropType).isRequired,
  onItemSelected: PropTypes.func.isRequired,
  buildTagProps: PropTypes.func,
};
